const schema = [
  {
    "commonName": "Vertebrates & relatives",
    "scientificName": "Chordata",
    "class": [
      {
        "commonName": "Mammals",
        "scientificName": "Mammalia",
        "order": [
          {
            "commonName": "Primates",
            "scientificName": "Primates",
            "genus": [
              {
                "commonName": "Macaques",
                "scientificName": "Macaca",
                "species": [
                  { "commonName": "Long-tailed macaque", "scientificName": "Macaca fascicularis" }
                ]
              },
              {
                "commonName": "Ring-tailed lemurs",
                "scientificName": "Lemur",
                "species": [
                  { "commonName": "Ring-tailed lemur", "scientificName": "Lemur catta" }
                ]
              }
            ]
          },
          {
            "commonName": "Carnivores",
            "scientificName": "Carnivora",
            "genus": [
              {
                "commonName": "Servals",
                "scientificName": "Leptailurus",
                "species": [
                  { "commonName": "Serval", "scientificName": "Leptailurus serval" }
                ]
              },
              {
                "commonName": "Hyenas",
                "scientificName": "Crocuta",
                "species": [
                  { "commonName": "Spotted hyena", "scientificName": "Crocuta crocuta" }
                ]
              }
            ]
          },
          {
            "commonName": "Even-toed ungulates",
            "scientificName": "Artiodactyla",
            "genus": [
              {
                "commonName": "Pigs",
                "scientificName": "Sus",
                "species": [
                  { "commonName": "Bearded pig", "scientificName": "Sus barbatus" }
                ]
              }
            ]
          },
          {
            "commonName": "Rodents",
            "scientificName": "Rodentia",
            "genus": [
              {
                "commonName": "Capybaras",
                "scientificName": "Hydrochoerus",
                "species": [
                  { "commonName": "Capybara", "scientificName": "Hydrochoerus hydrochaeris" }
                ]
              }
            ]
          }
        ]
      },
      {
        "commonName": "Birds",
        "scientificName": "Aves",
        "order": [
          {
            "commonName": "Hornbills and allies",
            "scientificName": "Bucerotiformes",
            "genus": [
              {
                "commonName": "Great hornbills",
                "scientificName": "Buceros",
                "species": [
                  { "commonName": "Great hornbill", "scientificName": "Buceros bicornis" }
                ]
              },
              {
                "commonName": "Pied hornbills",
                "scientificName": "Anthracoceros",
                "species": [
                  { "commonName": "Oriental pied hornbill", "scientificName": "Anthracoceros albirostris" }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
];

export { schema };
